<script>
import MultiSelectHint from '@/components/ui/MultiSelectHint.vue'
import { getDispatchAssignees } from '@/api/cars'

export default {
  components: {
    'mia-multi-select-hint': MultiSelectHint
  },

  props: {
    value: {
      type: String,
      default: null
    }
  },

  data: () => ({
    dispatchAssignees: [],
    selectedDispatchAssignee: []
  }),

  created() {
    this.parseInitialValue()
    this.loadDispatchAssignees()
  },

  methods: {
    async loadDispatchAssignees() {
      this.$wait.start('loading available dispatch assignees')
      const [error, data] = await getDispatchAssignees()
      this.$wait.end('loading available dispatch assignees')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Zuständige für die Auslieferung konnten nicht geladen werden']
        })
        return
      }

      this.dispatchAssignees = data
    },

    parseInitialValue() {
      if (!this.value) {
        return
      }

      try {
        const payload = JSON.parse(this.value)

        this.selectedDispatchAssignee = payload.dispatch_assignee || []
      } catch (e) {
        // left blank intentionally
      }
    },

    onChange() {
      const payload = {
        dispatch_assignee: this.selectedDispatchAssignee
      }

      this.$emit('change', JSON.stringify(payload))
    }
  }
}
</script>

<template>
  <div>
    <div>
      <label class="text-sm block mb-1 mr-2 tracking-wider text-gray-800">Zuständig für die Auslieferung</label>
      <mia-wait for="loading available dispatch assignees">
        <template #waiting>
          <div class="flex items-center justify-center py-8">
            <mia-wave-loader />
          </div>
        </template>

        <template #default>
          <select
            v-model="selectedDispatchAssignee"
            class="w-full form-select"
            multiple
            size="6"
            @change="onChange"
          >
            <option value="">
              (leer)
            </option>
            <option
              v-for="assignee in dispatchAssignees"
              :key="assignee.id"
              :value="assignee.id"
            >
              {{ assignee.item_full_name }}
            </option>
          </select>
          <mia-multi-select-hint />
        </template>
      </mia-wait>
    </div>
  </div>
</template>
